module.exports = __webpack_public_path__ + "static/media/logoLarge.d802ff07.png";